/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-09-23 15:19:52
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-05 15:01:48
 */
import { Button, Form, Select, Spin, Tabs, Tree, notification } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { ApplicationType } from '../../app/applicationSlice'
import { NavBar } from '../../compnents/nav/NavBar'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { GrantMenus } from './Grant'
import { ThreeGrantMenus } from './ThreeGrant'
import styles from './Grant.module.css'
import { useLocation } from 'react-router-dom'
import { getThirdTenantMenuTree, setThirdTenantMenuTree, getThirdMemberMenuTree, setThirdMemberMenuTree } from './grantSlice'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { unwrapResult } from '@reduxjs/toolkit'

export const GrantPage = (): ReactElement => {
  const [selectedTab, setSelectedTab] = useState('0')

  const location: any = useLocation()

  const [loading, setLoading] = useState(false)

  const flag = location.search.replace('?', '')

  const { tenantId, userId } = useParams<{
    tenantId?: string
    userId: string
  }>()

  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const { Option } = Select

  // const layout = {
  //   labelCol: { span: 6 },
  //   wrapperCol: { span: 18 },
  // }

  const Rules = [
    {
      required: true,
    },
  ]
  interface Option {
    value: string | number;
    label?: React.ReactNode;
    disabled?: boolean;
    children?: Option[];
    // 标记是否为叶子节点，设置了 `loadData` 时有效
    // 设为 `false` 时会强制标记为父节点，即使当前节点没有 children，也会显示展开图标
    isLeaf?: boolean;
  }

  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>(['0-0']);
  const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
  // const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [treeData, setTreeData] = useState<any>([])

  const onExpand = (expandedKeysValue: React.Key[]) => {
    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };

  const onCheck = (checkedKeysValue: any, e: any) => {
    setCheckedKeys(checkedKeysValue);
    // setSelectedKeys(e.checkedNodes)
  };

  const onSelect = (selectedKeysValue: React.Key[], info: any) => {
    console.log('onSelect', info);
  };

  // 获取所有选中节点的父节点
  const getParentKeys = (treeData: any, key: number) => {
    const parentKeys: any = [];
    const dfs = (nodes: any, parent: any) => {
      nodes.forEach((node: any) => {
        if (node.key === key) {
          parentKeys.push(parent);
        } else if (node.children) {
          dfs(node.children, node.key);
        }
      });
    };
    dfs(treeData, null);
    return parentKeys;
  }

  //获取节点的数据
  const getNodeData = (treeData: any, key: number) => {
    let nodeKey: any = {};
    const dfs = (nodes: any) => {
      nodes.forEach((node: any) => {
        if (node.key === key) {
          nodeKey = node;
        } else if (node.children) {
          dfs(node.children);
        }
      });
    };
    dfs(treeData);
    return nodeKey;
  }

  const getData = () => {
    dispatch(userId ? getThirdMemberMenuTree({userId}) : getThirdTenantMenuTree({ tenantId }))
      .then(unwrapResult)
      .then((res: any) => {
        if (res) {
          const tree = res.map((el: any) => ({
            title: el.menuName,
            key: el.id,
            ...el,
            children: el?.subMenus?.map((v: any) => ({
              ...v,
              title: v.menuName,
              key: v.id,
              children: v?.subMenus?.map((n: any) => ({
                ...n,
                title: n.menuName,
                key: n.id,
                children: n?.subMenus?.map((g: any) => ({
                  ...g,
                  title: g.menuName,
                  key: g.id,
                }))
              }))
            }))
          }))
          const data = [
            {
              title: '全部',
              key: 0,
              children: tree
            }
          ]
          // 默认选中
          const defaultSelectList: any = []
          res.forEach((el: any) => {
            // 一级菜单
            if (el?.subMenus?.length > 0 && el.status == 1) {
              el?.subMenus?.forEach((v: any) => {
                // 二级菜单
                if (v?.subMenus?.length > 0 && v.status == 1) {
                  v?.subMenus?.forEach((n: any) => {
                    // 三级菜单
                    if (n?.subMenus?.length > 0 && n.status == 1) {
                      n?.subMenus?.forEach((m: any) => {
                        // 四级菜单
                        if (m?.subMenus?.length > 0 && m.status == 1) {
                          m?.subMenus?.forEach((g: any) => {
                            // 五级菜单
                            if (g.status == 1) {
                              defaultSelectList.push(g)
                            }
                          })
                        } else {
                          if (m.status == 1) {
                            defaultSelectList.push(m)
                          }
                        }
                      })
                    } else {
                      if (n.status == 1) {
                        defaultSelectList.push(n)
                      }
                    }
                  })
                } else {
                  if (v.status == 1) {
                    defaultSelectList.push(v)
                  }
                }
              })
            } else {
              if (el.status == 1) {
                defaultSelectList.push(el)
              }
            }

          })
          setCheckedKeys(defaultSelectList.map((v: any) => v.id))
          // setSelectedKeys(defaultSelectList)
          setTreeData(data)
        }

      })
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      {tenantId && (
        <NavBar
          style={{ margin: '10px 20px' }}
          where={['机构管理', '功能设定']}
          backtrace={{
            name: '机构管理',
            path: '/admin/tenant',
          }}
        />
      )}
      <div className={styles.content}>
        <Spin spinning={loading}>
          <Form
            form={form}
            // {...layout}
            onFinish={(values) => {
              console.log(tenantId, userId);
              
              setLoading(true)
              let checkIds: any = []
              checkedKeys?.forEach((v: any) => {
                checkIds.push(...getParentKeys(treeData, v))
              })
              checkIds = Array.from(new Set(checkIds.concat(checkedKeys)))?.filter(v => !!v)
              let newCheckIds: any = []
              checkIds?.forEach((v: any) => {
                newCheckIds.push(...getParentKeys(treeData, v))
              })
              newCheckIds = Array.from(new Set(newCheckIds.concat(checkIds)))?.filter(v => !!v)
              let finailyCheckIds: any = []
              newCheckIds?.forEach((v: any) => {
                finailyCheckIds.push(...getParentKeys(treeData, v))
              })
              finailyCheckIds = Array.from(new Set(finailyCheckIds.concat(newCheckIds)))?.filter(v => !!v)
              const data = finailyCheckIds?.map((v: any) => {
                const node = getNodeData(treeData, v)
                return {
                  level: node?.level,
                  menuId: node?.menuId
                }
              })
              console.log(finailyCheckIds, data);

              dispatch(userId ? setThirdMemberMenuTree({ userId, tenantId, menuList: data }) : setThirdTenantMenuTree({ tenantId, menuList: data }))
                .then(unwrapResult)
                .then(() => {
                  setLoading(false)
                  notification.success({
                    message: '操作成功'
                  })
                  form.resetFields()
                  getData()
                })
            }}
          >
            <Form.Item name='openDoctor' label=''>
              <Tree
                checkable
                onExpand={onExpand}
                // expandedKeys={expandedKeys}
                // autoExpandParent={autoExpandParent}
                onCheck={onCheck}
                checkedKeys={checkedKeys}
                // onSelect={onSelect}
                // selectedKeys={selectedKeys}
                treeData={treeData}
              />
            </Form.Item>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <Button type="primary" onClick={() => form.submit()}>
                确认
              </Button>
            </div>
          </Form>
        </Spin>
        {/* <Tabs
          activeKey={selectedTab}
          defaultActiveKey='0'
          onChange={(v: any) => setSelectedTab(v)}
        >
          <Tabs.TabPane key='0' tab='一二级菜单'>
            <GrantMenus
              type={ApplicationType.Management}
              tenantId={tenantId}
              userId={userId}
              selectedTab={selectedTab}
            />
          </Tabs.TabPane>
          {!flag ? (
            <Tabs.TabPane key='1' tab='二三级菜单'>
              <ThreeGrantMenus
                type={ApplicationType.Management}
                tenantId={tenantId}
                userId={userId}
                selectedTab={selectedTab}
              />
            </Tabs.TabPane>
          ) : (
            <></>
          )}
        </Tabs> */}
      </div>
    </>
  )
}
